import { axios as axiosNoAuth } from "services";

export const taxApi = {
  getCountyAndState: (stateName, countyId = "") => {
    const params = new URLSearchParams({ stateName, countyId });
    return axiosNoAuth.get(`/admin/stateAndCountyTax?${params.toString()}`);
  },

  updateStateTax: (body) => {
    return axiosNoAuth.post("/admin/stateAndCountyTax/createTax", body);
  },

  updateState: (body) => {
    return axiosNoAuth.post("/admin/stateAndCountyTax/state", body);
  },

  addNewCounty: (body) => {
    return axiosNoAuth.post("/admin/stateAndCountyTax/createCounty", body);
  },

  updateCountyTax: (body) => {
    return axiosNoAuth.post("/admin/stateAndCountyTax/updateCountyTax", body);
  },

  uploadZipCodes: (body) => {
    return axiosNoAuth.post("/admin/stateAndCountyTax/upload", body);
  },
  addZipCode: (body) => {
    return axiosNoAuth.post("/admin/stateAndCountyTax/zipcode-add", body);
  },
  updateZipCode: (body) => {
    return axiosNoAuth.put("/admin/stateAndCountyTax/zipcode-update", body);
  },
  deleteZipCode: (body) => {
    return axiosNoAuth.delete("/admin/stateAndCountyTax/zipcode-delete", { data: body });
  },
};
